import { useGetAllMySuppliers } from '@/api/supplier.api';
import ViewFlightForm from '@/components/flight/ViewFlightForm';
import Loader from '@/components/ui/Loader';
import { useGetFlight } from '@/hooks/useFlight';
import { useResourceLanguage } from '@/hooks/useResourceLanguage';
import { memo } from 'react';
import { useParams } from 'react-router';

const ViewFlightFormMemo = memo(ViewFlightForm);

const ViewFlightPage = () => {
  const { benefitId = '' } = useParams();

  const { language, setLanguage } = useResourceLanguage();

  const { data: flight, isLoading, isSuccess } = useGetFlight(benefitId);
  const { data: suppliers } = useGetAllMySuppliers();
  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewFlightFormMemo
        key={`flight-${flight.id}`}
        flight={flight}
        suppliers={suppliers}
        language={language}
        setLanguage={setLanguage}
      />
    )
  );
};

export default ViewFlightPage;
